import { FC } from 'react'
import { AlertCircle, RotateCw } from 'lucide-react'

interface ErrorViewProps {
  message: string
  fullScreen?: boolean
  onRetry?: () => void
}

const ErrorView: FC<ErrorViewProps> = ({ message, fullScreen = true, onRetry }) => {
  const handleRetry = () => {
    if (onRetry) onRetry()
    else window.location.reload()
  }

  return (
    <div className={`flex items-center justify-center z-50 ${fullScreen ? 'fixed inset-0' : 'py-12'}`}>
      <div className="rounded-xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] shadow-lg max-w-md w-full mx-4">
        <div className="flex flex-col items-center text-center p-8">
          <AlertCircle className="h-12 w-12 text-[hsl(var(--destructive))] mb-4" />
          <h2 className="text-lg font-semibold mb-4">{message}</h2>
          <button
            className="inline-flex items-center gap-2 h-10 px-4 rounded-[var(--radius)] bg-[hsl(var(--primary))] text-white font-medium text-sm hover:bg-[hsl(var(--primary))]/90 transition-colors"
            onClick={handleRetry}
          >
            <RotateCw className="h-4 w-4" />
            Try Again
          </button>
        </div>
      </div>
    </div>
  )
}

export default ErrorView
